import React from "react";
import ReactDOM from "react-dom";
import { WbMarkdownHtml, wbStripHtmlEvents } from "../../utils/common";
import ImgIconComp from "../imgcomp";
import MeetingTopHeaderLeft from "./meetingTopHeaderLeft";
import MeetingTopHeaderRight from "./meetingTopHeaderRight";
import MeetingAttendeePopup from "./modals/meetingAttendeePopup";
import MeetingAttendeeOpts from "./meetingAttendeeOpts";
import MainDetailsMeetingWrapper from "./mainDetailsMeetingWrapper";

class MeetingApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      meetingDetails: this.props.meetingData,
      showTopicDescEdit: false,
      takeTopic: [],
      mentionsUserData: null,
      enableDesc: false,
      showAddAttendeePopup: false,
      showAttendeeOpts: false,
      attendeeOptId: null,
      tempVar: false,
      takeTopicId: "",
      emptyGlobalTag: 0,
      disabledDoneBtn: 0,
      resetTopicTag: 0,
      topicEmptyData: []
    };
    window.MeetingApp = this;
    this.defaultDescState = this.defaultDescState.bind(this);
    this.wsNameUpdate = this.wsNameUpdate.bind(this);
    this.registerMeetingSubscription = this.registerMeetingSubscription.bind(
      this
    );
    this.removeTypingAlert = this.removeTypingAlert.bind(this);
    this.joinHandler = this.joinHandler.bind(this);
    this.leftHandler = this.leftHandler.bind(this);
    this.typingHandler = this.typingHandler.bind(this);
    this.syncMeetingData = this.syncMeetingData.bind(this);
    this.editTopicArea = this.editTopicArea.bind(this);
    this.shareMeetingTopic = this.shareMeetingTopic.bind(this);
    this.saveTags = this.saveTags.bind(this);
    this.saveMeetingInvitees = this.saveMeetingInvitees.bind(this);
    this.updateMeetingName = this.updateMeetingName.bind(this);
    this.removeMeetingInvitee = this.removeMeetingInvitee.bind(this);
    this.updateMeetingInviteeAccess = this.updateMeetingInviteeAccess.bind(
      this
    );
    this.saveMeetingNullTopicNote = this.saveMeetingNullTopicNote.bind(this);
    this.saveMeetingTopic = this.saveMeetingTopic.bind(this);
    this.clearQuickAddParams = this.clearQuickAddParams.bind(this);
    this.updateTopicTake = this.updateTopicTake.bind(this);
    this.currentDateTime = this.currentDateTime.bind(this);
    this.saveMeetingTakeAway = this.saveMeetingTakeAway.bind(this);
    this.deleteTopicTakeNonTake = this.deleteTopicTakeNonTake.bind(this);
    this.enablegroupText = this.enablegroupText.bind(this);
    this.addDesc = this.addDesc.bind(this);
    this.showAddAttendeePopupClick = this.showAddAttendeePopupClick.bind(this);
    this.showAttendeeOptsDiv = this.showAttendeeOptsDiv.bind(this);
    this.hideAttendeeOptsDiv = this.hideAttendeeOptsDiv.bind(this);
    this.keypress = this.keypress.bind(this);
    this.cKeditorLoad = this.cKeditorLoad.bind(this);
    this.sortItemNotes = this.sortItemNotes.bind(this);
    this.sortTakeNotes = this.sortTakeNotes.bind(this);
    this.addTopicAttach = this.addTopicAttach.bind(this);
    this.addNoteAttach = this.addNoteAttach.bind(this);
    this.deleteTopicAttach = this.deleteTopicAttach.bind(this);
    this.deleteNoteAttach = this.deleteNoteAttach.bind(this);
    this.clearGlobalValue = this.clearGlobalValue.bind(this);
    this.clearGlobalValueBta = this.clearGlobalValueBta.bind(this);
    this.emptyDOM = this.emptyDOM.bind(this);
  }

  componentDidMount() {
    const _this = this;
    $(document).on("ws_name_update_comp", {}, this.wsNameUpdate);
    this.defaultDescState();
    // window.addEventListener("click", this.handleBodyClick, true);
    const { meeting, currentUser, selectedUser } = this.props.meetingData;

    if (meeting.status == "1") {
      this.registerMeetingSubscription(meeting.id, currentUser.id);
    }

    let { name } = meeting;
    if (meeting.type == 1) {
      name = `1on1 with ${selectedUser.fullName}`;
    }
    updateRecentItemsTopMenu(meeting.id, "recent_meeting", name);
    highlightLeftMenuNav("meeting", meeting.id, "meeting", meeting);

    // TODO: refactor this jquery stuff out asap
    $(document).off("click", "#reopen-meeting-confirm #reopen_meeting_btn");
    $(document).on(
      "click",
      "#reopen-meeting-confirm #reopen_meeting_btn",
      () => {
        _this.emptyDOM();
        $(document).trigger("meeting_comp_safe_render");
      }
    );
    $(document).on("unmount_meeting_app_comp", {}, this.emptyDOM);

    this.meetingAppRef.addEventListener("paste", this.trimHTMLTagsOnPaste, true);
  }

  componentWillUnmount() {
    this.meetingAppRef.removeEventListener("paste", this.trimHTMLTagsOnPaste, true);
    // window.removeEventListener("click", this.handleBodyClick);
    // window.addEventListener("click", this.workstreamListPopupClose, true);
    window.MeetingApp = null;
  }

  emptyDOM() {
    if (document.getElementById("msDetailsPage")) {
      ReactDOM.unmountComponentAtNode(document.getElementById("msDetailsPage"));
    }
  }

  defaultDescState() {
    const defult = !!$.trim(this.props.meetingData.meeting.objective);
    this.setState({
      enableDesc: defult
    });
  }

  trimHTMLTagsOnPaste = (e) => {
    if (!e) return
    // stop data being pasted into div via default paste
    e.preventDefault();

    // get pasted data via clipboard API
    if (e.clipboardData) {
      const content = e.clipboardData.getData('text/plain');
      const plainContent = this.stripHtmlTags(content);
      const linkedContent = this.makeLinksClickable(plainContent);
      this.pasteHtml(linkedContent);
    }
    else if (window.clipboardData) {
      const content = window.clipboardData.getData('Text');
      const trimmedData = this.stripHtmlTags(content);
      if (window.getSelection) {
        window.getSelection().getRangeAt(0).insertNode(document.createTextNode(trimmedData));
      }
    }

    // on some browsers, this is required as a fallback for e.preventDefault() not being consistent in behavior
    return false;
  }

  // strip all HTML tags except for <a>
  stripHtmlTags = (str) => {
    const tmp = document.createElement("div");
    tmp.id = "tmp";
    tmp.innerHTML = str;
    document.body.appendChild(tmp);

    $("#tmp *").each(function () {
      if ($(this).is("br")) {
        $(this).remove();
      }
      var content = $(this).contents();
      $(this).replaceWith(content);
    });

    const cleanStr = tmp.innerHTML;
    tmp.remove();
    return cleanStr;
  }

  // parses a string and wraps anything that looks like urls with <a>
  makeLinksClickable = (str) => {
    let paragraphs = str.split("\n");
    let paragraphsCopy = [];
    paragraphs = paragraphs.filter(Boolean); // removes empty lines
    paragraphs.forEach(function (p) {
      let words = p.split(" ");
      let wordsCopy = [];
      words = words.filter(Boolean); // removes multiple spaces together
      words.forEach(function (w) {
        if (w.substring(0, 4) === "www." || w.substring(0, 7) === "http://" || w.substring(0, 8) === "https://") {
          wordsCopy.push("<span>" + w + "</span>");
        } else {
          wordsCopy.push(w);
        }
      });
      paragraphsCopy.push(wordsCopy.join(" "));
    });
    return paragraphsCopy.join("<br>");
  }

  pasteHtml = (html) => {
    let sel, range, node, lastNode;
    if (window.getSelection) { // standard browsers and IE9+
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        let el = document.createElement("div");
        el.innerHTML = html;
        let fragment = document.createDocumentFragment();
        while (node = el.firstChild) {
          lastNode = fragment.appendChild(node);
        }
        range.insertNode(fragment);
        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    } else if (document.selection && document.selection.type != "Control") { // IE8 and older
      document.selection.createRange().pasteHTML(html);
    }
  }

  wsNameUpdate(e, args) {
    const { actions } = this.props;
    if (typeof args.wsName !== "undefined") {
      actions.MeetingWorkstreamNameUpdate(args.wsId, args.wsName);
    }
  }

  registerMeetingSubscription(meetingID, userId) {
    // Daryoush requested to disable websockets until we have a better grasp on locking
    // https://cameronbothner.com/pessimistic-locking/
    return

    const _this = this;
    const allEvents = {
      typing: 1,
      joined: 2,
      left: 3,
      createTopic: 4,
      createTakeAways: 5
    };

    // unregister meet event
    unregister("meet");

    // nodeUrl is defined the js variable in controller.
    // c_id is user session ie) also defined in controller.
    const host = `${wbConfig.nodeUrl}/meets`;
    const csrfToken = $.ajaxSetup().data.YII_CSRF_TOKEN;
    const socketConnection = {
      reconnect: false,
      "try multiple transports": false,
      query: `csrf=${csrfToken}&cId=${wbConfig.client_id}`,
      extra: "header_1_test"
    };

    // connect socket.io
    const meetingSocket = io.connect(host, socketConnection);

    // start heart beat once socket is connected.
    setTimeout(() => {
      meetingSocket.emit("ping", { beat: 1 });
    }, 25000);

    // register meet event with meeting id and user id
    register("meet", { mS: meetingSocket, mId: meetingID, uId: userId });
    const gUserId = getUserId();
    if (typeof userId === "undefined") {
      userId = gUserId;
    }

    meetingSocket.on("connect", () => {
      // update the socket again once gets connected
      register("meet", { mS: meetingSocket, mId: meetingID, uId: userId });
      // send join message
      meetingSocket.emit("join", { id: meetingID, uid: userId });
    });

    /**
     * When connecting
     */
    meetingSocket.on("connecting", () => {
      // console.log('connecting');
    });

    /** *
     * On disconnect, handle it gracefully
     */
    meetingSocket.on("disconnect", () => {
      // send join message
      meetingSocket.emit("leave", { id: meetingID });
      // console.log('disconnect');
      // clear the name space
      meetingSocket.io.nsps = {};
    });

    meetingSocket.on("pong", data => {
      // console.log("pong..");
    });
    meetingSocket.on("connect_failed", () => {
      // console.log('connect_failed');
    });
    meetingSocket.on("error", err => {
      // console.log('error: ' + err);
    });
    meetingSocket.on("reconnect_failed", () => {
      // console.log('reconnect_failed');
    });
    meetingSocket.on("reconnect", () => {
      // console.log('reconnected ');
    });
    meetingSocket.on("reconnecting", () => {
      // console.log('reconnecting');
    });

    meetingSocket.on("meeting", data => {
      if (typeof data.type !== "undefined") {
        const eventType = data.type;
        switch (eventType) {
          case allEvents.typing:
            _this.typingHandler(data);
            break;
          case allEvents.left:
            _this.leftHandler(data.id);
            break;
          case allEvents.joined:
            _this.joinHandler(data.id);
            // once joining is done, notify the user that you are also in the meeting with
            // me_too signal
            // console.log("Emit me_too signal as you are also in");
            meetingSocket.emit("me_too", { id: data.mid, uid: gUserId });
            break;
          case allEvents.createTopic:
            if (typeof data.mData !== "undefined") {
              _this.removeTypingAlert();
              _this.syncMeetingData(data.mData);
            }
            break;
          case allEvents.createTakeAways:
            // createTakeAwaysHandler();
            break;
        }
      }
    });
  }

  /**
   * removing typing handler
   */
  removeTypingAlert() {
    $("#topic")
      .delay(100)
      .fadeOut();
  }

  /**
   * joining the meeting.
   * @param {*} userId
   */
  joinHandler(userId) {
    const photoSelector = $(
      `div.teamMeetingInviteeImgDiv[data-member-id='${userId}']`
    );
    const foundPhotoSelector = photoSelector.find(".roundFramePhoto");
    foundPhotoSelector.addClass("member-live");
    foundPhotoSelector.css("position", "relative");
    // before adding the div, remove it if available
    photoSelector.find(".typingImage").remove();
    photoSelector.append("<div class='typingImage'></div>");
    // by default for one on one, show the id
    $("#typing-alert").show();
    foundPhotoSelector.animate(
      {
        top: -25
      },
      2000,
      "easeOutBounce"
    );

    foundPhotoSelector.css("position", "static");
  }

  leftHandler(userId) {
    const photoSelector = $(
      `div.teamMeetingInviteeImgDiv[data-member-id='${userId}']`
    );
    const photoFinderSelector = photoSelector.find(".roundFramePhoto");
    photoSelector.find(".typingImage").remove();
    photoFinderSelector.removeClass("member-live");
    // for one on one, remove the image
    $("#typing-alert").hide();
  }

  typingHandler(data) {
    const topicSelector = $("#topic");
    if (data.show) {
      topicSelector.delay(100).fadeIn();
      let name = data.uData.fullName;
      if (
        typeof name !== "undefined" &&
        name !== null &&
        name.trim().length > 0
      ) {
        const nameSplit = name.split(" ");
        if (nameSplit.length > 0) {
          name = nameSplit[0];
        }
      }
      $("#topic-text")
        .html("")
        .text(`${name} is typing`);
    } else {
      topicSelector.delay(100).fadeOut();
    }
  }

  syncMeetingData(data) {
    const { actions } = this.props;
    if (typeof data.type !== "undefined" && data.data !== "undefined") {
      actions.MeetingSyncData(data);
    }
  }

  editTopicArea() {
    const _this = this;
    setTimeout(() => {
      _this.setState({
        showTopicDescEdit: true
      });
    }, 10);
  }

  shareMeetingTopic(id, access) {
    const { actions } = this.props;
    const _this = this;
    let url = "";
    if (access == 0) {
      url = wbConfig.baseUrl + '/meeting/shareThisTopic';
      access = 1;
    } else if (access == 1) {
      url = wbConfig.baseUrl + '/meeting/unshareThisTopic';
      access = 0;
    }
    const fieldData = { id };
    $.post(url, fieldData, (data, status) => {
      if (status == "success") {
      }
    });
    actions.MeetingUpdateShareTopic(id, { access });
  }

  saveTags(meetingId, tagId, stateId, TypeStr, act, topicId = null) {
    const { actions, meetingData } = this.props;
    if (act == "edit") {
      let wsId = null;
      const tagVal = -11;
      if (tagId == 1) {
        wsId =
          meetingData.meeting.ws_id != null
            ? meetingData.meeting.ws_id
            : tagVal;
      }
      var fieldData = `&YII_CSRF_TOKEN=${$.ajaxSetup().data.YII_CSRF_TOKEN}`;
      var fieldData = `${fieldData}&meeting_id=${meetingId}&tag=${tagId}&id=${stateId}&type=${TypeStr}&tagId=${wsId}`;
      let url = "";
      if (TypeStr == "topic") {
        url = wbConfig.baseUrl + '/meeting/saveMeetingTopic';
      } else {
        url = wbConfig.baseUrl + '/meeting/saveMeetingTake';
      }
      $.post(url, fieldData, (data, status) => {
        // return false;
        if (status == "success") {
          if (tagId == "1") {
            if (TypeStr == "topic") {
              actions.MeetingUpdateTopic(stateId, {
                ai_id: data.data.ai_id,
                aiOwnerName: data.data.aiOwnerName,
                wobo_type: data.data.wobo_type,
                wobo_data: data.data.wobo_data
              });
            } else if (TypeStr == "nonTake") {
              actions.MeetingUpdateNonTake(stateId, {
                ai_id: data.data.ai_id,
                aiOwnerName: data.data.aiOwnerName
              });
            } else {
              actions.MeetingTopicTakeUpdate(stateId, topicId, {
                ai_id: data.data.ai_id,
                aiOwnerName: data.data.aiOwnerName,
                wobo_data: data.data.wobo_data
              });
            }
          }
          create_topic("meet", {
            action: "tag_update",
            type: TypeStr,
            data: data.data,
            topicId
          });
        }
      });
      if (TypeStr == "topic") {
        actions.MeetingAddTopicTag(stateId, tagId, { id: stateId, tagId });
      } else if (TypeStr == "nonTake") {
        actions.MeetingAddNonTopicTag(stateId, tagId, { id: stateId, tagId });
      } else {
        actions.MeetingAddTakeTag(stateId, tagId, topicId, {
          id: stateId,
          tagId,
          topicId
        });
      }
    }
  }
  resetMeetingTakesForSmartWobo = resetValue => {
    this.props.actions.resetMeetingTakesForSmartWobo(resetValue);
  };

  getPredictionResultForTakeaway = response => {
    if (response.data && response.data.results) {
      const resultData = response.data.results.filter(result => {
        if (result.WBAIpredictionType === "ActionItem") {
          return true;
        }
      });
      if (resultData && Array.isArray(resultData) && resultData.length && resultData[0].score) {
        return resultData[0].score;
      }
    } else {
      return false;
    }
  };

  saveTakeawayAsAi = (topicId, aiOwnerId, meetingId, tagId, stateId, act) => {
    const { actions, meetingData } = this.props;
    const TypeStr = "take";

    if (act == "edit") {
      let wsId = null;
      const tagVal = -11;
      if (tagId == 1) {
        wsId =
          meetingData.meeting.ws_id != null
            ? meetingData.meeting.ws_id
            : tagVal;
      }
      let fieldDataStructure = {
        YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
        meeting_id: meetingId,
        tag: tagId,
        id: stateId,
        type: TypeStr,
        tagId: wsId,
        userId: aiOwnerId
      };
      const url = wbConfig.baseUrl + '/meeting/saveMeetingTake';

      $.post(url, fieldDataStructure, (data, status) => {
        if (status == "success") {
          if (tagId == "1") {
            actions.MeetingTopicTakeUpdate(stateId, topicId, {
              ai_id: data.data.ai_id,
              aiOwnerName: data.data.aiOwnerName,
              wobo_data: data.data.wobo_data
            });
          }
          create_topic("meet", {
            action: "tag_update",
            type: TypeStr,
            data: data.data,
            topicId
          });
        }
      });

      actions.MeetingAddTakeTag(stateId, tagId, topicId, {
        id: stateId,
        tagId,
        topicId
      });
    }
  };

  saveMeetingInvitees(meetingId, responseVal) {
    const { actions } = this.props;
    actions.MeetingUpdateInvitees(meetingId, { inviteeVal: responseVal });

    this.setState({
      showAddAttendeePopup: false
    });
  }

  updateMeetingName(meetingName) {
    const { actions } = this.props;
    actions.MeetingNameUpdate({ meetingName });
  }

  removeMeetingInvitee(userId) {
    const { actions } = this.props;
    actions.MeetingRemoveInvitee({ userId });
  }

  updateMeetingInviteeAccess(userId, isAdminVal) {
    const { actions } = this.props;
    actions.MeetingUpdateInviteeAccess({ userId, isAdminVal });
  }

  saveMeetingNullTopicNote(
    desc,
    meetingId,
    tag,
    pos,
    fname,
    lname,
    topicRelId,
    quickAddAI = false,
    quickAddAIParams = {},
    callback = null
  ) {
    const textEmpty = "";
    const textTag = 0;
    const wobo_type = "topic";
    const { actions } = this.props;
    const curDateTime = this.currentDateTime();
    const _this = this;
    const randNum = Math.floor(Math.random() * 10000000) + 1;
    const tempAiId = randNum;
    const access = 1;
    const canEdit = true;
    const canDelete = true;
    const added_by = this.props.meetingData.currentUser.id;

    actions.MeetingAddTopicItems({
      id: tempAiId,
      description: textEmpty,
      pos,
      tag: textTag,
      meeting_id: meetingId,
      firstname: fname,
      lastname: lname,
      create_period: curDateTime,
      access,
      canEdit,
      canDelete,
      added_by,
      wobo_type,
      aiOwnerName: fname
    });

    let fieldDatas = {
      YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
      meeting_id: meetingId,
      description: desc,
      tag,
      pos,
      topicId: topicRelId
    };
    if (quickAddAI == true) {
      fieldDatas.tag = 1;
      fieldDatas = Object.assign({}, fieldDatas, quickAddAIParams);
    }
    const fieldId = `meeting_take_${meetingId}${topicRelId != "" ? `_${topicRelId}` : ""
      }`;
    const fieldObj = $(`#${fieldId}`);
    const addAiUrlNote = `${wbConfig.baseUrl}/meeting/saveMeetingTake`;
    $.post(addAiUrlNote, fieldDatas, (response, status) => {
      $(fieldObj).prop("disabled", true);
      if (response.error) {
        $(fieldObj).val(desc);
        actions.MeetingDelteTopic(tempAiId);
        alert(response.error);
      } else if (status == "success") {
        _this.clearQuickAddParams(fieldObj);
        actions.MeetingUpdateTopicId(tempAiId, response.data.id, response.data);
        create_topic("meet", {
          action: "add",
          data: response.data,
          type: "topic"
        });

        if (typeof callback === "function") {
          callback.call(_this, response.data.takeId, desc);
        }
      }
    });
  }

  saveMeetingTopic(
    desc,
    meetingId,
    tag,
    pos,
    fname,
    lname,
    wobo_type,
    quickAddAI = false,
    quickAddAIParams = {},
    topicToTake = false
  ) {
    const { actions } = this.props;
    const curDateTime = this.currentDateTime();
    const _this = this;
    const addAiUrl = `${wbConfig.baseUrl}/meeting/saveMeetingTopic`;
    const randNum = Math.floor(Math.random() * 10000000) + 1;
    const tempAiId = randNum;
    const access = 1;
    const canEdit = true;
    const canDelete = true;
    const added_by = this.props.meetingData.currentUser.id;
    const tagId = this.props.meetingData.meeting.ws_id;
    let fieldData = {
      YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
      description: desc,
      meeting_id: meetingId,
      tag,
      pos
    };
    if (quickAddAI == true) {
      tag = 1;
      fieldData.tag = tag;
      fieldData = Object.assign({}, fieldData, quickAddAIParams);
      if (!fieldData.tagId) {
        fieldData.tagId = tagId;
      }
    }

    if (topicToTake != true) {
      actions.MeetingAddTopicItems({
        id: tempAiId,
        description: wbStripHtmlEvents(desc),
        pos,
        tag,
        meeting_id: meetingId,
        firstname: fname,
        lastname: lname,
        create_period: curDateTime,
        access,
        canEdit,
        canDelete,
        added_by,
        wobo_type,
        aiOwnerName: fname
      });
    }
    const fieldObj = $(`#meeting_topic_${meetingId}`);
    if (topicToTake == true) {
      $(fieldObj).val(desc).html(desc)
    }
    const posting = $.post(addAiUrl, fieldData, (response, status) => {
      $(fieldObj).prop("disabled", true);
      removeLoaderWidget();
      if (response.error) {
        $(fieldObj).val(desc);
        actions.MeetingDelteTopic(tempAiId);
        alert(response.error);
      } else if (status == "success") {
        _this.clearQuickAddParams(fieldObj);
        if (topicToTake == true) {
          $(fieldObj).val(desc).html(desc)
          _this.setState({
            takeTopicId: response.data.id,
            emptyGlobalTag: tag,
            topicEmptyData: response.data
          });
          if ($(`#cke_meeting_take_${meetingId}`).length == 0) {
            $(`#meeting_take_${meetingId}`).trigger("click");
          }
        } else {
          create_topic("meet", {
            action: "add",
            data: response.data,
            type: "topic"
          });
          actions.MeetingUpdateTopicId(
            tempAiId,
            response.data.id,
            response.data
          );
          _this.setState({
            takeTopicId: ""
          });
        }
      }
    });
    // TODO: add handling block; what if save fails?
  }

  clearQuickAddParams(obj) {
    $(obj).data("teamId", "");
    $(obj).data("quickAddTagId", "");
    $(obj).data("quickAddUserId", "");
    $(obj).data("quickAddAI", "");
    $(obj).val("");
  }

  updateTopicTake(
    desc,
    meetingId,
    topicId,
    tagId,
    fname,
    lname,
    TypeStr,
    takeId = null,
    quickAddAI = false,
    quickAddAIParams = {},
    callback = null,
    updateFromEmpty = false,
    topicToTake = false
  ) {
    const _this = this;
    const { actions } = this.props;

    let fieldData = {
      YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
      meeting_id: meetingId,
      description: desc,
      tag: tagId,
      id: topicId,
      type: TypeStr
    };

    if (quickAddAI == true) {
      fieldData.tag = 1;
      fieldData = Object.assign({}, fieldData, quickAddAIParams);
    }

    let url = "";
    let fieldObj = "";
    if (TypeStr == "topic") {
      url = wbConfig.baseUrl + '/meeting/saveMeetingTopic';
      fieldObj = $(
        `#meeting_topic_${meetingId}${topicId != "" ? `_${topicId}` : ""}`
      );
    } else if (TypeStr == "nonTake") {
      url = wbConfig.baseUrl + '/meeting/saveMeetingTake';
      fieldObj = $(
        `#meeting_take_${meetingId}${topicId != "" ? `_${topicId}` : ""}`
      );
    } else {
      url = wbConfig.baseUrl + '/meeting/saveMeetingTake';
      fieldObj = $(
        `#meeting_take_${meetingId}${topicId != "" ? `_${topicId}` : ""}`
      );
    }

    if (TypeStr == "topic" && topicToTake == true) {
      $(fieldObj).val(desc).html(desc)
    }
    $.post(url, fieldData, (data, status) => {
      removeLoaderWidget();
      $(fieldObj).prop("disabled", true);
      if (data.error) {
        $(fieldObj).val(desc);
        alert(data.error);
        window.location.reload();
        return false;
      } else if (status == "success") {
        _this.clearQuickAddParams(fieldObj);
        if (updateFromEmpty) {
          create_topic("meet", {
            action: "add",
            data: _this.state.topicEmptyData,
            type: "topic"
          });
          actions.MeetingAddTopicItems(_this.state.topicEmptyData);
          _this.setState({ takeTopicId: "" });
        }
        if (data.data) {
          if (TypeStr == "topic") {
            if (_this.state.topicEmptyData.length > 0) {
              actions.MeetingUpdateTopic(
                topicId,
                _this.state.topicEmptyData.data
              );
            } else {
              actions.MeetingUpdateTopic(topicId, data.data);
            }
            if (topicToTake == true) {
              $(fieldObj).val(desc).html(desc)
              _this.setState({
                takeTopicId: data.data.id,
                emptyGlobalTag: tagId,
                topicEmptyData: data.data
              });
              if ($(`#cke_meeting_take_${meetingId}`).length == 0) {
                $(`#meeting_take_${meetingId}`).trigger("click");
              }
            }
          } else if (TypeStr == "nonTake") {
            actions.MeetingUpdateNonTake(topicId, data.data);
          } else {
            actions.MeetingTopicTakeUpdate(topicId, takeId, data.data);
          }
          create_topic("meet", {
            action: "update",
            type: TypeStr,
            data: data.data,
            topicId: takeId
          });
        }
        if (typeof callback === "function") {
          callback.apply(null, [desc, topicId]);
        }
      }
    });
  }

  currentDateTime() {
    // TODO: move to /utils or use an existing utility method
    const m = moment.utc();
    let timestamp = m.format("X");
    const { currentUser } = this.props.meetingData;
    let offset = 0;
    if (typeof currentUser.offset !== "undefined") {
      offset = currentUser.offset;
      if (offset != null && offset != "") {
        timestamp = parseInt(timestamp) + offset;
      }
    }
    return moment.utc(timestamp * 1000).format("hh:mm a MMM DD");
  }

  saveMeetingTakeAway(
    desc,
    meetingId,
    tag,
    pos,
    fname,
    lname,
    topicRelId,
    quickAddAI = false,
    quickAddAIParams = {},
    callback = null,
    fromTopicAdd = false,
    smart_suggest_utilized = 0
  ) {
    const { actions } = this.props;

    let fieldData = {
      YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
      meeting_id: meetingId,
      description: desc,
      tag,
      pos,
      topicId: topicRelId,
      fromTopicAdd,
      smart_suggest_utilized
    };
    if (quickAddAI == true) {
      fieldData.tag = 1;
      fieldData = Object.assign({}, fieldData, quickAddAIParams);
    }
    const fieldId = `meeting_take_${meetingId}${topicRelId != "" ? `_${topicRelId}` : ""
      }`;
    const fieldObj = $(`#${fieldId}`);
    const _this = this;
    const addAiUrl = `${wbConfig.baseUrl}/meeting/saveMeetingTake`;

    const posting = $.post(addAiUrl, fieldData, (response, status) => {
      $(fieldObj).prop("disabled", true);
      if (response.error) {
        $(fieldObj).val(desc);
        alert(response.error);
      } else if (status == "success") {
        actions.MeetingAddTopicTakeAwayItems(topicRelId, response.data);
        create_topic("meet", {
          action: "add",
          data: response.data,
          type: "take",
          topicId: topicRelId
        });
        _this.clearQuickAddParams(fieldObj);
        if (typeof callback === "function") {
          callback.call(_this, response.data.id, desc);
        }
        if (topicRelId != "" && fromTopicAdd == true) {
          actions.MeetingAddNewTopicItems(response.data);
          _this.setState({
            tempVar: false,
            takeTopicId: "",
            emptyGlobalTag: 0
          });
        }
      }
    });
    this.setState({
      emptyGlobalTag: 0
    });
  }

  deleteTopicTakeNonTake(ids, meetingId, type, topicId = null) {
    const { actions } = this.props;

    let url = "";
    let data = "";
    if (type == "topic") {
      url = wbConfig.baseUrl + '/meeting/deleteMeetingTopic';
      data = { id: ids };
    } else if (type == "nonTake") {
      url = wbConfig.baseUrl + '/meeting/deleteMeetingTake';
      data = { id: ids };
    } else if (type == "take") {
      url = wbConfig.baseUrl + '/meeting/deleteMeetingTake';
      data = { id: ids, topicId };
    }
    if (typeof url !== "undefined") {
      $.ajax({
        url,
        type: "post",
        data
      }).done(status => {
        if (status === "ok") {
          create_topic("meet", {
            action: "delete",
            type,
            data: { id: ids },
            topicId
          });
        }
      });
    }
    if (type == "topic") {
      const desc = "";
      const tagId = 0;
      const curDateTime = "NULL";
      const ai_id = "NULL";
      const aiOwnerName = "NULL";
      actions.MeetingUpdateTopic(ids, {
        description: desc,
        tag: tagId,
        create_period: curDateTime
      });
      actions.MeetingUpdateTopic(ids, { ai_id, aiOwnerName });
    } else if (type == "nonTake") {
      actions.MeetingDeleteNonTakeAway(ids, { ids });
    } else {
      actions.MeetingDeleteTopicTakeAway(ids, topicId, { ids, topicId });
    }
  }

  enablegroupText() {
    const _this = this;
    _this.setState({
      enableDesc: !this.state.enableDesc
    });
  }

  addDesc(content, id) {
    const { actions } = this.props;

    const objective = content;
    if (objective == "") {
      $(".noObjectiveDes").show();
    }
    $(".pencilImg").show();
    const eleIdB = "objective";
    const instance = CKEDITOR.instances[eleIdB];
    if (instance) {
      CKEDITOR.instances[eleIdB].destroy();
    }
    actions.MeetingUpdateObject(id, { objective });
    this.forceUpdate();

    // TODO: better fail-state/error handling below
    $.ajax({
      url: `${wbConfig.baseUrl}/meeting/updateMeetingObj`,
      type: "post",
      data: { id, objective }
    })
      .done(response => {
        if (response.error) {
          //console.log(response.error);
        }
      })
      .fail(response => {
        //console.log("Please try again later", response);
      });
  }

  showAddAttendeePopupClick() {
    this.setState(prevState => ({
      showAddAttendeePopup: !prevState.showAddAttendeePopup
    }));
  }

  showAttendeeOptsDiv(attendeeOptIdVal) {
    const selectedUser = this.props.meetingData;
    const showAttendeeOpts = !!(
      selectedUser.userPermission.meetingAccess &&
      selectedUser.meeting.status == 1
    );
    this.setState({
      showAttendeeOpts,
      attendeeOptId: attendeeOptIdVal
    });
  }

  hideAttendeeOptsDiv() {
    this.setState({
      showAttendeeOpts: false,
      attendeeOptId: null
    });
  }

  keypress() {
    const rows1 = $(".planMeetingTextarea").val();
    if (rows1) {
      const rows = rows1.split("\n");
      this.setState({
        descHeight: rows + 1
      });
    }
  }

  cKeditorLoad(enableDesc) {
    const _this = this;
    const eleIdB = "objective";
    $(".pencilImg").hide();
    $(".noObjectiveDes").hide();
    if (enableDesc) {
      const meetingId = this.state.meetingDetails.meeting.id;
      CKEDITOR.disableAutoInline = true;
      CKEDITOR.timestamp = css_js_version_control;
      const EditorV = CKEDITOR.replace(eleIdB, {
        extraAllowedContent: "a(documentation);abbr[title];code",
        extraPlugins: "chkstrike,confighelper,linkclickable,autogrow,pasteFromGoogleDoc",
        uploadUrl: "/uploader/upload.php",
        autoGrow_onStartup: true,
        resize_enabled: false,
        autoGrow_bottomSpace: 0,
        line_height: "8px",
        sharedSpaces: {
          top: "top2"
        },
        fillEmptyBlocks: false,
        shiftEnterMode: CKEDITOR.ENTER_BR,
        enterMode: CKEDITOR.ENTER_BR,
        allowedContent: true,
        entities: false,
        basicEntities: false
      });
      EditorV.on("instanceReady", ev => {
        ev.editor.focus();
        const s = ev.editor.getSelection(); // getting selection
        let selected_ranges = s.getRanges(); // getting ranges
        let node = selected_ranges[0].startContainer; // selecting the starting node
        const parents = node.getParents(true);
        if (parents && parents.length > 2) {
          node = parents[parents.length - 2].getFirst();
        }
        while (true) {
          const x = node.getNext();
          if (x == null) {
            break;
          }
          node = x;
        }
        s.selectElement(node);
        selected_ranges = s.getRanges();
        selected_ranges[0].collapse(false); //  false collapses the range to the end of the selected node, true before the node.
        s.selectRanges(selected_ranges); // putting the current selection there
      });
      EditorV.on("blur", () => {
        // return;
        const content = EditorV.getData();
        _this.addDesc(content, meetingId);
      });
    }
  }

  sortItemNotes(id, list) {
    const { actions } = this.props;
    actions.MeetingUpdateSortData(id, { item: list });
  }

  sortTakeNotes(id, list) {
    const { actions } = this.props;
    actions.MeetingTakeUpdateSortData(id, { item: list });
  }

  addTopicAttach(topicId, list) {
    const { actions } = this.props;
    actions.MeetingTopicAttachAdd(topicId, { item: list });
  }

  addNoteAttach(topicid, takeid, list) {
    const { actions } = this.props;
    actions.MeetingNoteAttachAdd(topicid, takeid, { item: list });
  }

  deleteTopicAttach(topicId, id) {
    const { actions } = this.props;
    actions.MeetingTopicAttachDelete(topicId, { id });
  }

  deleteNoteAttach(topicid, takeid, id) {
    const { actions } = this.props;
    actions.MeetingNoteAttachDelete(topicid, takeid, { id });
  }
  
  clearGlobalValue() {
    this.setState({
      disabledDoneBtn: 1
    });
  }

  clearGlobalValueBta() {
    if (this.state.resetTopicTag == 0) {
      this.setState({
        disabledDoneBtn: 0,
        emptyGlobalTag: 0,
        resetTopicTag: 3
      });
    } else {
      this.setState({
        disabledDoneBtn: 0,
        emptyGlobalTag: 0,
        resetTopicTag: 0
      });
    }
  }

  urlify(text) {
    if (text && typeof text !== "undefined" && text.length > 0) {
      const urlRegex = /((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;
      return text.replace(urlRegex, "<a href='$1' target='_blank'>$1</a>");
    }
    return text;
  }

  trimParagraphTag = desc => {
    return desc.replace("<p></p>", "");
  };

  render() {
    const selectedUser = this.props.meetingData;
    const textFieldDesc = selectedUser.meeting.type != 1;
    const currentUserSubscription = !!selectedUser.userPermission
      .currentUserSubscription;
    const showAddAttendeeIcon = !!selectedUser.userPermission.meetingAccess;
    const meetingId = selectedUser.meeting.id;
    const goal = selectedUser.meeting.objective;
    const isGoal = !$.trim(goal);
    return (
      <div
        key={`meeting_details_${meetingId}`}
        className="mainDiv meetingDetailsMainDiv"
        ref={elem => this.meetingAppRef = elem}
        id={'meeting_details_div'}
      >
        <div className="width100 meeting1on1-wrapper">
          <div className="padLeft10">
            <div className="left sixtyWidth">
              <MeetingTopHeaderLeft
                selectedUser={selectedUser}
                updateMeetingName={this.updateMeetingName}
              />
            </div>
            <div className="right fourthWidth rightHeadTop floatLeft">
              <MeetingTopHeaderRight
                {...this.props.meetingData}
                actions={this.props.actions}
              />
            </div>
            <div className="clear" />
            {selectedUser.meeting.type == 1 && (
              <div style={{ float: "left", paddingTop: "2%", width: "41%" }}>
                <div style={{ width: "46px", float: "left" }}>&nbsp;</div>
                <div style={{ float: "left" }}>
                  <div
                    title={meetingLoc}
                    dangerouslySetInnerHTML={WbMarkdownHtml(
                      this.urlify(meetingLoc)
                    )}
                  />
                </div>
              </div>
            )}
            {selectedUser.meeting.type == 1 ? (
              <MeetingRightSection vg_1on1={selectedUser.vg_1on1} />
            ) : (
              ""
            )}

            <div className="clear" />
          </div>
        </div>
        {textFieldDesc ? (
          <div className="team-meeting-attendee-list dispIB padBottom10">
            <div className="team-meeting-attendee team-meeting-attendee-img">
              {selectedUser.meeting_invitees != null &&
                Object.keys(selectedUser.meeting_invitees).length
                ? Object.keys(selectedUser.meeting_invitees).map(
                  (item, index) =>
                    selectedUser.meeting_invitees[index].access == 1 ? (
                      <div
                        key={index}
                        onMouseEnter={() =>
                          this.showAttendeeOptsDiv(
                            selectedUser.meeting_invitees[index].user_id
                          )
                        }
                        onMouseLeave={() => this.hideAttendeeOptsDiv()}
                        className="teamMeetingInviteeImgDiv left"
                        data-member-id={
                          selectedUser.meeting_invitees[index].user_id
                        }
                      >
                        <ImgIconComp
                          class="fitProfileImage roundFramePhoto team-meeting-attendee-pic fitProfileImage"
                          srcUrl={
                            selectedUser.meeting_invitees[index].picture
                          }
                          width="35"
                          height="35"
                          title={
                            selectedUser.meeting_invitees[index].user_name
                          }
                        />
                        {this.state.showAttendeeOpts &&
                          selectedUser.meeting.owner !=
                          selectedUser.meeting_invitees[index].user_id &&
                          this.state.attendeeOptId ==
                          selectedUser.meeting_invitees[index].user_id &&
                          selectedUser.currentUser.id !=
                          selectedUser.meeting_invitees[index].user_id && (
                            <MeetingAttendeeOpts
                              meetingId={
                                selectedUser.meeting_invitees[index]
                                  .meeting_id
                              }
                              userId={
                                selectedUser.meeting_invitees[index].user_id
                              }
                              isAdmin={
                                selectedUser.meeting_invitees[index].is_admin
                              }
                              removeMeetingInvitee={this.removeMeetingInvitee}
                              updateMeetingInviteeAccess={
                                this.updateMeetingInviteeAccess
                              }
                            />
                          )}
                      </div>
                    ) : (
                      ""
                    )
                )
                : ""}
              {showAddAttendeeIcon && selectedUser.meeting.status == "1" && (
                <div
                  className="team-meeting-add-attendee team-meeting-attendee-img"
                  ref={node => {
                    this.node = node;
                  }}
                >
                  <img
                    src={`${wbConfig.baseUrl}/images/meeting_assets/add@3x.png`}
                    width="24"
                    height="24"
                    onClick={this.showAddAttendeePopupClick}
                  />
                  {this.state.showAddAttendeePopup && (
                    <MeetingAttendeePopup
                      attendeeList={selectedUser.meeting_invitees}
                      userTeamList={selectedUser.userTeamList}
                      meetingId={selectedUser.meeting.id}
                      saveMeetingInvitees={this.saveMeetingInvitees}
                      team_contribution={selectedUser.meeting.team_contribution}
                      showAddAttendeePopupClick={this.showAddAttendeePopupClick}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="dispIB" />
        )}
        {textFieldDesc && (
          <div className="dispIB groupDesc">
            <span
              className="meetingDescText"
              onClick={e => this.enablegroupText(e)}
            >
              Description
              <ImgIconComp
                id={this.state.enableDesc ? "up_meeting" : "down_meeting"}
                width="20"
                height="20"
                style={{ float: "right" }}
              />{" "}
            </span>
          </div>
        )}
        {this.state.enableDesc && (
          <div className="desc-element">
            <div
              className="planMeetingTextarea"
              placeholder="Description (optional)"
              name="objective"
              id="objective"
              ref="meeting_objective"
              dangerouslySetInnerHTML={WbMarkdownHtml(
                this.trimParagraphTag(goal)
              )}
            />
            {currentUserSubscription &&
              showAddAttendeeIcon &&
              selectedUser.meeting.status == 1 ? (
              <div style={{ display: "inline-block" }}>
                {isGoal && (
                  <div
                    className="noObjectiveDes"
                    style={{ display: "inline-block" }}
                  >
                    Description (optional)
                  </div>
                )}
                <img
                  className="pencilImg"
                  width="15px"
                  src={`${wbConfig.imageCdnUrl}/images/goal/pencil.png`}
                  onClick={e => this.cKeditorLoad(true)}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        )}
        
        <MainDetailsMeetingWrapper
          actions={this.props.actions}
          {...this.props.meetingData}
          saveMeetingTopic={this.saveMeetingTopic}
          saveTags={this.saveTags}
          saveMeetingTakeAway={this.saveMeetingTakeAway}
          editTopicArea={this.editTopicArea}
          showTopicDescEdit={this.props.showTopicDescEdit}
          deleteTopicTakeNonTake={this.deleteTopicTakeNonTake}
          updateTopicTake={this.updateTopicTake}
          shareMeetingTopic={this.shareMeetingTopic}
          mentionsUserData={this.state.mentionsUserData}
          sortItemNotes={this.sortItemNotes}
          saveMeetingNullTopicNote={this.saveMeetingNullTopicNote}
          sortTakeNotes={this.sortTakeNotes}
          deleteTopicAttach={this.deleteTopicAttach}
          deleteNoteAttach={this.deleteNoteAttach}
          addTopicAttach={this.addTopicAttach}
          addNoteAttach={this.addNoteAttach}
          clearGlobalValue={this.clearGlobalValue}
          tempVar={this.state.tempVar}
          takeTopicId={this.state.takeTopicId}
          emptyGlobalTag={this.state.emptyGlobalTag}
          disabledDoneBtn={this.state.disabledDoneBtn}
          clearGlobalValueBta={this.clearGlobalValueBta}
          resetTopicTag={this.state.resetTopicTag}
          saveTakeawayAsAi={this.saveTakeawayAsAi}
          resetMeetingTakesForSmartWobo={this.resetMeetingTakesForSmartWobo}
        />
        <div className="clear" />
      </div>
    );
  }
}

// meeting_takeaways_head
const MeetingRightSection = props => {
  const vg_1on1 = props.vg_1on1 || {};
  const vg_text = vg_1on1.text || "";
  const vg_class = vg_1on1.class || "";
  const vg_style = {};

  return (
    <div
      className="left vg-1on1 width100"
      style={{ paddingTop: "2%", width: "59%" }}
    >
      <div className="innserSect">
        <div className="width100 orgcontent-vg-wrapper-1o1_pg" style={vg_style}>
          <div
            className={vg_class}
            dangerouslySetInnerHTML={{ __html: vg_text }}
          />
        </div>
        <div className="clear" />
      </div>
    </div>
  );
};

export default MeetingApp;
